import { logNewRelicError, NEW_RELIC_LOG_ERRORS } from '@namespace/analytics';

type ReducerHandler<State, Payload> = (state: State, payload: Payload) => State;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Handlers<State> = Record<string, ReducerHandler<State, any>>;

const baseReducer = <State>(
  handlers: Handlers<State> = {},
  customHandlers: Handlers<State> = {}
) => {
  const mergedHandlers = { ...handlers, ...customHandlers };
  return (state: State, action: { type: string; payload: unknown }): State => {
    try {
      return mergedHandlers[action.type]
        ? mergedHandlers[action.type](state, action.payload)
        : state;
    } catch (e) {
      logNewRelicError(e, NEW_RELIC_LOG_ERRORS.REDUCER, { type: action.type });
      return state;
    }
  };
};

export default baseReducer;
